// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"aec72b50","276":"46ba42d8","400":"b04e58c6","511":"60d0f5ff","562":"879189f5","817":"5e739242","905":"afe285cc"}[chunkId] + ".chunk.js";
};